<template>
  <div>
    <basic-container>
      <!--下拉列表-->
      <!--<template >-->
      <!--<el-select v-model="value" placeholder="请选择"  @change="statusChange">-->
      <!--<el-option-->
      <!--v-for="item in statusData"-->
      <!--:key="item.value"-->
      <!--:label="item.label"-->
      <!--:value="item.value">-->
      <!--</el-option>-->
      <!--</el-select>-->
      <!--</template>-->

      <avue-crud
        :option="tableOption"
        :data="tableData"
        :table-loading="tableLoading"
        :page="page"
        ref="crud"
        @search-change="searchChange"
        @refresh-change="refreshChange"
        @search-reset="searchClear"
        @row-save="handleSave"
        @row-update="handleUpdate"
        @size-change="pageSizeChange"
        @current-change="pageChange"
      >
        <!-- 自定义搜索清空需要调用清空方法 -->
        <!-- <template slot="searchMenu">
          <el-button
            size="small"
            class="el-icon-delete"
            @click="searchClear"
            style="width: 80px;left: 0px;position: relative;"
          >清空</el-button>
        </template>-->
        <template slot="search">
          <el-form-item
            label="服务类目"
            size="small"
            style="margin-top: 4px"
          >
            <el-col :md="32">
              <el-select
                v-model="serviceCategory"
                placeholder="请选择服务类目"
                required
                @change="choseWorkServiceItem"
                value-key="id"
              >
                <el-option
                  v-for="serviceCategory in serviceCategorys"
                  :key="serviceCategory.id"
                  :label="serviceCategory.name"
                  :value="serviceCategory"
                ></el-option>
              </el-select>
            </el-col>
          </el-form-item>
          <el-form-item
            label="服务项目"
            size="small"
            style="margin-top: 4px"
          >
            <el-select
              v-model="serviceItem"
              placeholder="请选择服务项目"
              required
              @change="choseServiceItem"
              value-key="id"
            >
              <el-option
                v-for="joinsWorkServiceItem in joinsWorkServiceItems"
                :key="joinsWorkServiceItem.id"
                :label="joinsWorkServiceItem.name"
                :value="joinsWorkServiceItem.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </template>
        <template
          slot-scope="scope"
          slot="menuLeft"
        >
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="small"
            plain
            @click.stop="handleAdd()"
          >预约工单</el-button>
          <el-button
            type="success"
            icon="el-icon-download"
            size="small"
            plain
            @click.stop="downloadExcelWorkOrder"
          >下载Excel</el-button>
        </template>
        <template
          slot-scope="scope"
          slot="menu"
        >
          <el-button
            type="primary"
            icon="el-icon-edit"
            size="small"
            plain
            @click.stop="handleEdit(scope.row,scope.index)"
          >编辑</el-button>
          <el-button
            type="danger"
            icon="el-icon-close"
            size="small"
            plain
            v-if="scope.row.status=='IN_SERVICE'||scope.row.status=='FOR_SERVICE'||
                               scope.row.status=='WAIT_ACCEPT'||scope.row.status=='WAIT_DISTRIBUTE'||scope.row.status=='ENGINEER_ON_THE_WAY'"
            @click.stop="cancelWorkOrder(scope.row.id)"
          >取消工单</el-button>
          <!--<el-button type="primary"-->
          <!--icon="el-icon-check"-->
          <!--size="small"-->
          <!--plain-->
          <!--v-if="scope.row.status=='TO_BE_CONFIRMED'"-->
          <!--@click.stop="userPass(scope.row)"-->
          <!--&gt;确认工单-->
          <!--</el-button>-->
          <!--<el-button type="primary"-->
          <!--icon="el-icon-check"-->
          <!--size="small"-->
          <!--plain-->
          <!--v-if="scope.row.status=='TO_BE_CONFIRMED'"-->
          <!--@click.stop="userRefused(scope.row)"-->
          <!--&gt;拒绝工单-->
          <!--</el-button>-->
          <el-button
            type="success"
            icon="el-icon-view"
            size="small"
            plain
            v-if="scope.row.status=='WAIT_PAY'"
            @click.stop="openPay(scope.row)"
          >立即付款</el-button>
          <el-button
            type="success"
            icon="el-icon-edit-outline"
            size="small"
            plain
            v-if="scope.row.status=='TO_EVALUATE'||scope.row.status=='TO_BE_EVALUATED'"
            @click.stop="showEvaluate(scope.row)"
          >立即评价</el-button>
          <el-button
            type="success"
            icon="el-icon-view"
            size="small"
            plain
            @click.stop="serviceListing(scope.row)"
          >查看</el-button>
        </template>
        <!--<template slot-scope="scope" slot="workUserIdForm">-->
        <!--<el-select name="propertiesType" v-model="workerUser"-->
        <!--placeholder="请选择工程师"  value-key="id">-->
        <!--<el-option-->
        <!--v-for="user in users"-->
        <!--:key="user.id"-->
        <!--:label="user.realName"-->
        <!--:value="user.id">-->
        <!--</el-option>-->
        <!--</el-select>-->
        <!--</template>-->
        <template
          slot-scope="scope"
          slot="workUserIdForm"
        >
          <el-select
            v-model="workerUser"
            placeholder="请选择工程师"
            filterable="filterable"
            required
            value-key="id"
          >
            <el-option
              v-for="user in users"
              :key="user.id"
              :label="user.realName"
              :value="user"
            ></el-option>
          </el-select>
        </template>

        <template
          slot-scope="scope"
          slot="provinceForm"
        >
          <el-input
            type="input"
            name="title"
            disabled
            :value="point.pname"
          ></el-input>
        </template>
        <template
          slot-scope="scope"
          slot="cityForm"
        >
          <el-input
            type="input"
            name="title"
            disabled
            :value="point.cityname"
          ></el-input>
        </template>
        <template
          slot-scope="scope"
          slot="areaForm"
        >
          <el-input
            type="input"
            name="title"
            disabled
            :value="point.adname"
          ></el-input>
        </template>
        <template
          slot-scope="scope"
          slot="provincesForm"
        >
          <avue-map v-model="point"></avue-map>
        </template>
        <template
          slot-scope="scope"
          slot="serviceCategoryForm"
        >
          <el-select
            v-model="serviceCategory"
            placeholder="请选择服务类目"
            required
            @change="choseWorkServiceItem"
            value-key="id"
          >
            <el-option
              v-for="serviceCategory in serviceCategorys"
              :key="serviceCategory.id"
              :label="serviceCategory.name"
              :value="serviceCategory"
            ></el-option>
          </el-select>
        </template>
        <template
          slot-scope="scope"
          slot="serviceCategory"
        >{{scope.row.serviceCategoryName}}</template>
        <template
          slot-scope="scope"
          slot="serviceItems"
        >{{scope.row.serviceItemName}}</template>
        <template
          slot-scope="scope"
          slot="workUserId"
        >{{scope.row.realName}}</template>
        <template
          slot-scope="scope"
          slot="address"
        >{{scope.row.province}}{{scope.row.city}}{{scope.row.area}}{{scope.row.address}}</template>
        <template
          slot-scope="scope"
          slot="status"
        >
          <el-tag
            v-for="obj of workOrderStatus"
            :key="obj.value"
            v-if="obj.value == scope.row.status"
          >{{obj.label}}</el-tag>
        </template>
        <template
          slot-scope="scope"
          slot="serviceItemsForm"
        >
          <el-select
            v-model="serviceItem"
            placeholder="请选择服务项目"
            required
            @change="choseServiceItem"
            value-key="id"
          >
            <el-option
              v-for="joinsWorkServiceItem in joinsWorkServiceItems"
              :key="joinsWorkServiceItem.id"
              :label="joinsWorkServiceItem.name"
              :value="joinsWorkServiceItem.id"
            ></el-option>
          </el-select>
        </template>
      </avue-crud>
      <template>
        <el-dialog
          :visible.sync="rechargeDialog"
          title="充值"
          center
          width="1000px"
        >
          <div
            class="remittance"
            style="font-size: 14px;display: flex;flex-flow: column nowrap; align-items: flex-start;margin-left:205px"
          >
            <div class="recharge">
              <span style="width:130px;text-align:left;">请输入充值金额:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <el-input
                type="number"
                placeholder="请输入充值金额"
                v-model="rechargeMoney"
                style="width:215px"
              ></el-input>
            </div>
            <div style="display: flex;justify-content:flex-start;">
              <span style="width:130px;text-align:left;">支付方式:</span>
              <div>
                <el-radio
                  v-model="payRadio"
                  label="OFFLINE_REMIT"
                  @change="rechargeWayOFFLINE_REMIT"
                >线下汇款</el-radio>
                <el-radio
                  v-model="payRadio"
                  label="WX_PAY"
                  @change="rechargeWayWX_PAY"
                >微信支付</el-radio>
              </div>
            </div>
            <div
              class="recharge"
              v-if="this.payRadio == 'OFFLINE_REMIT'"
            >
              <span style="width:130px;text-align:left;">汇款账户名称:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <el-input
                type="text"
                placeholder="请输入汇款账户名称"
                v-model="remittanceAccountName"
                style="width:215px"
              ></el-input>
              <i style="font-style:normal;display: inline;font-size: 12px;color:red">&nbsp;&nbsp;个人储蓄卡请填写持卡人姓名，对公账户请填写账户名称</i>
            </div>
            <div
              class="recharge"
              v-if="this.payRadio == 'OFFLINE_REMIT'"
            >
              <span style="width:130px;text-align:left;">汇款账户:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <el-input
                type="text"
                placeholder="请输入汇款账户"
                v-model="remittanceAccount"
                style="width:215px"
              ></el-input>
            </div>
            <div
              class="recharge"
              v-if="this.payRadio == 'OFFLINE_REMIT'"
              style="display: flex;justify-content:flex-start;"
            >
              <span style="width:130px;text-align:left;">汇款银行:</span>
              <div>
                <el-select
                  placeholder="请输入汇款银行"
                  v-model="currBank"
                  style="width:215px"
                >
                  <el-option
                    v-for="item in remittanceBank"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div
              class="recharge"
              v-if="this.payRadio == 'OFFLINE_REMIT'"
              style=" margin-bottom:40px "
            >
              <span style="width:130px;text-align:left; ">凭证:</span>
              <el-upload
                :multiple="true"
                action="#"
                accept="image/jpeg, image/gif, image/png, image/bmp"
                :file-list="fileList1"
                :http-request="fnUploadremittanceImgs"
                :show-file-list="false"
              >
                <div
                  v-if="'' != remittanceImgs"
                  class="el-upload el-upload--picture-img"
                >
                  <img
                    v-for="remittanceImg of remittanceImgs"
                    :key="remittanceImg.value"
                    :src="remittanceImg"
                    style="width: 200px;"
                  />
                </div>
                <div
                  v-else
                  class="el-upload el-upload--car-two"
                >
                  <i class="el-icon-plus"></i>
                </div>
                <div class="el-upload__tip">请上传汇款回单凭证，只能上传jpg/png图片，且不超过500kb</div>
              </el-upload>
            </div>
            <div
              class="recharge"
              v-if="this.payRadio == 'OFFLINE_REMIT'"
            >
              <span style="width:130px;text-align:left;">账户名称:</span>
              成都聚家科技有限公司
            </div>
            <div
              class="recharge"
              v-if="this.payRadio == 'OFFLINE_REMIT'"
            >
              <span style="width:130px;text-align:left;">账户号码:</span>
              4402209109100103208
            </div>
            <div
              class="recharge"
              v-if="this.payRadio == 'OFFLINE_REMIT'"
            >
              <span style="width:130px;text-align:left;">开户银行:</span>
              中国工商银行股份有限公司成都天顺路支行
            </div>
            <div
              class="recharge"
              v-if="this.payRadio == 'OFFLINE_REMIT'"
            >
              <span style="width:130px;text-align:left;">汇款提示:</span>
              请避免北京时间18：00-00：00进行汇款，否则受银行出账时间影响，可能出现延迟一天到账情况。
            </div>
          </div>
          <div class="remittanceButton">
            <el-button
              round
              size="mini"
              @click="balancePayment"
            >&nbsp;&nbsp;&nbsp;立即充值&nbsp;&nbsp;&nbsp;</el-button>
            <el-button
              round
              type="danger"
              size="mini"
              @click="rechargeDialog = false"
            >&nbsp;&nbsp;&nbsp;取消&nbsp;&nbsp;&nbsp;</el-button>
          </div>
        </el-dialog>
      </template>
      <template>
        <el-dialog
          title="二维码支付"
          :visible.sync="QRCodeDialog"
          align="center"
        >
          <vue-qr
            :text="config.value"
            :size="200"
          ></vue-qr>
          <el-row>二维码只会展示2分钟，请及时支付</el-row>
          <el-button @click="destroyThisPay">关闭</el-button>
        </el-dialog>
      </template>
      <el-dialog
        title="选择付款方式"
        center
        :visible.sync="dialogBalancePay"
        width="50%"
      >
        <div style="display: flex;justify-content: space-around;">
          <el-radio
            v-if="!noMoney"
            v-model="balancePayRadio"
            label="YE"
          >账户余额({{getBalance+'元'}})</el-radio>
          <el-radio
            v-if="noMoney"
            v-model="balancePayRadio"
            label="YE"
          >
            账户余额(
            <span style="color:red">
              余额不足
              <a
                href="#"
                style="color:#409EFF;margin-left:3px;text-decoration: underline;"
                @click="toPayMoney"
              >去充值</a>
            </span>)
          </el-radio>
          <el-radio
            v-model="balancePayRadio"
            label="WX"
          >微信支付</el-radio>
        </div>
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button @click="dialogBalancePay = false">取 消</el-button>
          <el-button
            type="primary"
            @click="listPay"
          >确认支付</el-button>
        </span>
      </el-dialog>
      <el-dialog
        title="评价"
        :visible.sync="evaluateDialog"
        width="50%"
        style="background-color: #4E5465"
      >
        <el-row
          :gutter="20"
          style="margin: 10px;"
        >
          <el-rate
            v-model="evaluateObj.star"
            @change="rateChange()"
            show-text
          ></el-rate>
        </el-row>
        <el-row
          :gutter="20"
          style="margin: 10px;width: 50%;"
        >
          <el-input
            type="textarea"
            v-model="evaluateObj.content"
          ></el-input>
        </el-row>
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button @click="evaluateDialog = false">取 消</el-button>
          <el-button
            type="primary"
            @click="evaluate()"
          >确 定</el-button>
        </span>
      </el-dialog>
      <template>
        <el-dialog
          title="工单信息"
          :visible.sync="dataDialog"
          align="center"
        >
          <el-table
            :data="propertiesViceList"
            border
          >
            <el-table-column
              prop="secondClassifyName"
              align="center"
              label="字段名"
            >
              <template slot-scope="scope">{{scope.row.title}}</template>
            </el-table-column>
            <el-table-column
              prop="secondClassifyName"
              align="center"
              label="值"
            >
              <template slot-scope="scope">
                <template v-if="scope.row.dataType!='img'">{{scope.row.value}}</template>
                <template v-if="scope.row.dataType=='img'">
                  <viewer :images="formmaterImage(scope.row.value)">
                    <img
                      v-for="src in formmaterImage(scope.row.value)"
                      :src="src"
                      :key="src"
                      width="20"
                    />
                  </viewer>
                </template>
              </template>
            </el-table-column>
          </el-table>
          <el-table :data="serviceFee">
            <el-table-column
              prop="secondClassifyName"
              align="center"
              border
            >
              <template slot-scope="scope">{{scope.row.key}}</template>
            </el-table-column>
            <el-table-column
              prop="secondClassifyName"
              align="center"
              border
            >
              <template slot-scope="scope">{{scope.row.value}}</template>
            </el-table-column>
          </el-table>
        </el-dialog>
      </template>
    </basic-container>
  </div>
</template>

    <script>
import { mapGetters } from "vuex";
import { workOrderOption } from "@/const/salesCloud/workOrderOption";
import {
  serviceListing,
  statusSearch,
  findWorkOrderList,
  findCategoryAll,
  updateWorkOrderMerchants,
  evaluation,
  immediatePay,
  findItemsByCategory,
  findUsersByUserTypeAll,
  findUsersByUserType,
  balancePay,
  insertWorkOrderMerchants,
  userPass,
  userRefused,
  cancelWorkOrder,
  downloadExcelWorkOrder
} from "@/api/salesCloud/workOrder";
import { getAliyunPublicToken } from "@/api/oss/aliyun";
import oss from "ali-oss";
import md5 from "js-md5";
import { findBalance, addBalance } from "@/api/salesCloud/accountBalance";
import { wxNativePayQuery } from "@/api/salesCloud/depositRecharge";
import { findUserInfo } from "@/api/basic/user";
import { formatterDateToUTC, parseStatus } from "@/util/util";
import { DIC } from "@/const/dic";
import { exportExcel } from "xlsx-oc";
import VueQr from "vue-qr";
export default {
  name: "workOrder",
  components: {
    VueQr
  },
  data() {
    return {
      tableOption: workOrderOption, //表格设置属性
      tableData: [], //表格的数据
      tablePage: 1,
      tableLoading: false,
      dialogVisible: false,
      serviceCategoryId: "",
      serviceItemId: "",
      payTime: {},
      from: {
        text: ""
      },
      tabelObj: {},
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 10 //每页显示多少条
      },
      grade: {
        box: false,
        check: []
      },
      users: [],
      userType: "JOINS_ENGINEER",
      point: {},
      //余额支付
      balancePayRadio: "YE",
      serviceCategorys: [],
      serviceCategory: {},
      joinsWorkServiceItems: [],
      workOrderStatus: DIC.WORK_ORDER_STATUS,
      QRCodeDialog: false,
      config: {},
      noMoney: true,
      getBalance: 0,
      evaluateDialog: false,
      dialogBalancePay: false,
      rechargeDialog: false,
      rechargeMoney: "",
      payRadio: "OFFLINE_REMIT",
      remittanceAccountName: "",
      remittanceAccount: "",
      currBank: "",
      remittanceBank: DIC.BANK_LIST,
      fileList1: [],
      remittanceImgs: [],

      score: 5,
      clues: [],
      evaluateObj: {},
      paymentTask: {},
      serviceItem: {},
      workerUser: {},
      workOrderData: {},
      dataDialog: false,
      serviceFee: [],
      propertiesViceList: [],
      statusData: [
        {
          value: "WAIT_DISTRIBUTE",
          label: "待派发"
        },
        {
          value: "WAIT_ACCEPT",
          label: "待受理"
        },
        {
          value: "IN_SERVICE",
          label: "服务中"
        },
        {
          value: "TO_BE_CONFIRMED",
          label: "待确认(用户确认)"
        },
        {
          value: "TO_BE_THE_FINAL",
          label: "待终审"
        },
        {
          value: "WAIT_PAY",
          label: "待付款"
        },
        {
          value: "HAS_BEEN_RETURNED_USER",
          label: "已退回(用户退回)"
        },
        {
          value: "HAS_BEEN_RETURNED_USER_PLATFORM",
          label: "已退回(用户平台)"
        },
        {
          value: "TO_EVALUATE",
          label: "待评价"
        },
        {
          value: "TO_BE_EVALUATED",
          label: "待评价"
        },
        {
          value: "SOLVE",
          label: "已完成"
        },
        {
          value: "INVALID",
          label: "失效"
        }
      ],
      value: "",
      downloadData: {}
    };
  },
  created() {
    findCategoryAll().then(res => {
      console.log(res);
      let data = JSON.parse(res.data);
      this.serviceCategorys = data.rows;
    });
    let params = new Object();

    params.userType = this.userType;
    findUsersByUserTypeAll(params).then(res => {
      let data = JSON.parse(res.data);
      console.log(res);
      this.users = data.rows;
      for (let i = 0; i < this.users.length; i++) {
        let obj = this.users[i];
        obj.shouName = obj.realName + "(" + obj.mobile + ")";
      }
      // console.log("数据:"+JSON.stringify(this.users))
    });
    this.handleList();
  },
  watch: {},
  mounted() {},
  computed: {
    ...mapGetters(["permission"])
  },
  props: [],
  methods: {
    openPay(row) {
      console.log(row);
      this.payRow = row;
      findBalance().then(res => {
        let data = JSON.parse(res.data);
        this.getBalance = data.rows[0].balance;
        let wxPay = row.payMoney;
        // let wxPay = 1111111;
        console.log(wxPay, this.getBalance);
        this.noMoney = wxPay > this.getBalance;
        this.dialogBalancePay = true;
      });
    },
    getBalanceMoney() {
      findBalance().then(res => {
        let data = JSON.parse(res.data);
        this.getBalance = data.rows[0].balance;
        console.log(this.getBalance);
      });
    },
    listPay() {
      if (this.balancePayRadio == "WX") {
        this.immediatePayment(this.payRow);
      } else {
        let obj = {};
        obj.id = this.payRow.id;
        balancePay(obj).then(res => {
          console.log(res);
          if (res.code == "200") {
            this.$message({
              showClose: true,
              message: "支付成功",
              type: "success"
            });
            setTimeout(() => {
              this.handleList();
              console.log("延迟2s");
            }, 2000);
            this.dialogBalancePay = false;
          } else {
            this.$message({
              showClose: true,
              message: "余额不足",
              type: "error"
            });
            this.handleList();
            this.dialogBalancePay = false;
          }
        });
      }
    },
    destroyThisPay() {
      this.QRCodeDialog = false;
      this.rechargeDialog = false;
      this.payMoneyDialog = false;
      this.dialogBalancePay = false;
    },
    clean() {
      this.describeImgs = [];
      this.remittanceImgs = [];
      this.rechargeMoney = "";
      this.paymentTask = {};
      this.remittanceAccountName = "";
      this.remittanceAccount = "";
      this.currBank = "";
      this.workerUser = "";
      this.serviceItem = "";
    },
    balancePayment() {
      let params = {};
      params.money = this.rechargeMoney;
      params.rechargeType = "BALANCE";
      params.payType = this.payRadio;
      params.openingUser = this.remittanceAccountName;
      params.bankNumber = this.remittanceAccount;
      params.bankName = this.currBank;
      params.url = this.remittanceImgs + "";
      if (params.payType == "OFFLINE_REMIT") {
        if (
          params.money &&
          params.openingUser &&
          params.bankNumber &&
          params.bankName &&
          params.url
        ) {
          addBalance(params).then(res => {
            if (res.code == "200") {
              this.$message({
                showClose: true,
                message:
                  "非常感谢您对慧家平台的信任，请耐心等待平台财务人员核实。",
                type: "success"
              });
              this.rechargeDialog = false;
              this.payMoneyDialog = false;
              this.dialogBalancePay = false;
            } else {
              this.$message({
                showClose: true,
                message: res.message,
                type: "error"
              });
            }
          });
        } else {
          this.$message({
            showClose: true,
            message: "请完善输入信息",
            type: "error"
          });
        }
      } else {
        addBalance(params).then(response => {
          this.tableLoading = false;
          if (response.code == "200") {
            let data = response.data;
            let count = 0;
            wxNativePayQuery(data.outTradeNo).then(res => {
              if (res.code == "200") {
                if (res.data == "SUCCESS") {
                  let _this = this;
                  setTimeout(function() {
                    _this.QRCodeDialog = false;
                    _this.$message({
                      showClose: true,
                      message: "充值成功",
                      type: "success"
                    });
                    _this.handleList();
                    _this.payMoneyDialog = false;
                    _this.rechargeDialog = false;
                    _this.dialogBalancePay = false;
                  }, 1000);
                } else {
                  count++;
                  if (count < 3) {
                    wxNativePayQuery(data.outTradeNo).then(res => {
                      if (res.code == "200") {
                        if (res.data == "SUCCESS") {
                          let _this = this;
                          setTimeout(function() {
                            _this.QRCodeDialog = false;
                            _this.$message({
                              showClose: true,
                              message: "充值成功",
                              type: "success"
                            });
                            _this.handleList();
                            _this.payMoneyDialog = false;
                            _this.rechargeDialog = false;
                            _this.dialogBalancePay = false;
                          }, 1000);
                        } else {
                          this.QRCodeDialog = false;
                          this.rechargeDialog = false;
                          this.dialogBalancePay = false;
                          this.$message({
                            showClose: true,
                            message: "支付超时",
                            type: "error"
                          });
                        }
                      } else {
                        this.QRCodeDialog = false;
                        this.rechargeDialog = false;
                        this.dialogBalancePay = false;
                        this.$message({
                          showClose: true,
                          message: "支付超时",
                          type: "error"
                        });
                      }
                    });
                  }
                }
                //this.handleList();
              } else {
                this.QRCodeDialog = false;
                this.$message({
                  showClose: true,
                  message: "支付失败",
                  type: "error"
                });
                this.handleList();
              }
            });
            let start = new Date().getTime();
            while (true) if (new Date().getTime() - start > 1) break;
            this.config.value = "";
            this.config.value = data.codeUrl;
            this.QRCodeDialog = true;
          } else {
            this.$message({
              showClose: true,
              message: "支付失败",
              type: "error"
            });
            //???下面的感觉没用
            // this.$refs.crud.rowAdd();
            return;
          }
          // let data = JSON.parse(res.data);
        });
      }
    },
    rechargeWayBALANCE() {
      this.paymentTask.rechargeWay = "BALANCE";
    },
    rechargeWayWX_PAY() {
      this.paymentTask.rechargeWay = "WX_PAY";
    },
    rechargeWayOFFLINE_REMIT() {
      this.paymentTask.rechargeWay = "OFFLINE_REMIT";
    },
    toPayMoney() {
      console.log("充值");
      this.clean();
      this.rechargeDialog = true;
    },

    statusChange() {
      //下拉框状态发生改变时
      //console.log(this.value);
      let params = this.value;
      statusSearch(params).then(res => {
        let data = JSON.parse(res.data);
        console.log(data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      (params.page = this.page.currentPage), (params.size = pageSize);
      findWorkOrderList(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize
        };
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page;
      params.size = this.page.pageSize;
      findWorkOrderList(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    searchClear() {
      //有搜索回调不用直接方法调用
      //自定义搜索需要调用清空方法
      // this.$refs.crud.$refs.searchForm.resetFields()
      this.serviceCategory = "";
      this.serviceCategoryId = "";
      this.serviceItem = "";
      this.serviceItemId = "";
      console.log(this);
    },
    searchChange(params) {
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm
      // //搜索前置清空
      // 传空值
      params.serviceCategoryId = "";
      params.serviceItemId = "";
      params.startTime = "";
      params.endTime = "";
      params.startPayTime = "";
      params.endPayTime = "";
      // 对象属性删除
      //   delete params.serviceCategoryId
      //   delete params.serviceItemId
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      this.serviceCategoryId = this.serviceCategory.id
        ? this.serviceCategory.id
        : "";
      if (
        null != params.startDate_endDate &&
        undefined != params.startDate_endDate &&
        "" != params.startDate_endDate
      ) {
        params.startTime = params.startDate_endDate[0];
        params.endTime = params.startDate_endDate[1];
      }
        if (
        null != params.payTimeInterval &&
        undefined != params.payTimeInterval &&
        "" != params.payTimeInterval
      ) {
        params.startPayTime = params.payTimeInterval[0];
        params.endPayTime = params.payTimeInterval[1];
      }
      // console.log(this.$refs.crud.resetForm)
      if (this.serviceCategoryId) {
        params.serviceCategoryId = this.serviceCategoryId;
        if (this.serviceItemId) {
          params.serviceItemId = this.serviceItemId;
        }
      }
      //支付时间区间搜索
      // console.log(params)
      // var searchStartTime = new Date(this.payTime[0]);
      // var searchEndTime = new Date(this.payTime[1]);
      // searchStartTime=searchStartTime.getFullYear() + '-' + (searchStartTime.getMonth() + 1) + '-' + searchStartTime.getDate() + ' ' + searchStartTime.getHours() + ':' + searchStartTime.getMinutes() + ':' + searchStartTime.getSeconds();
      // searchEndTime=searchEndTime.getFullYear() + '-' + (searchEndTime.getMonth() + 1) + '-' + searchEndTime.getDate() + ' ' + searchEndTime.getHours() + ':' + searchEndTime.getMinutes() + ':' + searchEndTime.getSeconds();
      // searchStartTime = new Date(searchStartTime).getTime()
      // searchEndTime = new Date(searchEndTime).getTime()
      this.downloadData = params;
      console.log(params);
      console.log(this);
      findWorkOrderList(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: params.page,
          pageSize: params.size
        };
        this.tableLoading = false;
      });
    },
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page.currentPage;
      params.size = page.pageSize;
      findWorkOrderList(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize
        };
        this.tableLoading = false;
      });
    },

    handleDetail(row, index) {},
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd() {
      this.clean();
      this.point = {};
      this.serviceCategory = {};
      this.joinsWorkServiceItems = [];
      this.$refs.crud.rowAdd();
    },
    handleEdit(row, index) {
      console.log(row);
      this.workerUser = {};
      this.serviceCategory.id = row.serviceCategoryId;
      this.choseWorkServiceItem();
      this.workerUser.id = row.workerUserId;
      let location = {};
      console.log("集合：" + JSON.stringify(row));
      location.lng = row.longitude;
      location.lat = row.latitude;
      this.point.location = location;
      this.point.pname = row.province;
      this.point.cityname = row.city;
      this.point.adname = row.area;
      this.$refs.crud.rowEdit(row, index);
    },
    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let parmas = {
        page: this.page.currentPage,
        size: this.page.pageSize
      };
      findWorkOrderList(parmas).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave(row, done) {
      row.serviceCategoryId = this.serviceCategory.id;
      row.childList = this.childList;
      if (this.point.location) {
        row.longitude = this.point.location.lng;
        row.latitude = this.point.location.lat;
      } else {
        this.$message({
          showClose: true,
          message: "请选择坐标",
          type: "error"
        });
        done();
        return;
      }
      row.province = this.point.pname;
      row.city = this.point.cityname;
      row.area = this.point.adname;
      row.workerUserId = this.workerUser.id;
      row.serviceItemId = this.serviceItem;
      console.log("serviceItem：" + JSON.stringify(this.serviceItem));
      insertWorkOrderMerchants(row)
        .then(response => {
          if (response.code == "200") {
            this.$message({
              showClose: true,
              message: "添加成功",
              type: "success"
            });
            this.clean();
            this.handleList();
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error"
            });
          }
          this.clean();
        })
        .catch(error => {
          this.loading = false;
          this.clean();
          this.$message({
            showClose: true,
            message: error,
            type: "error"
          });
        });
      done();
    },
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate(row, index, done) {
      row.serviceCategoryId = this.serviceCategory.id;
      row.childList = this.childList;
      row.longitude = this.point.location.lng;
      row.latitude = this.point.location.lat;
      row.province = this.point.pname;
      row.city = this.point.cityname;
      row.area = this.point.adname;
      row.workerUserId = this.workerUser.id;
      console.log("集合：" + JSON.stringify(row));
      updateWorkOrderMerchants(row)
        .then(response => {
          if (response.code == "200") {
            this.$message({
              showClose: true,
              message: "修改成功",
              type: "success"
            });
            this.handleList();
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error"
            });
          }
        })
        .catch(error => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: error,
            type: "error"
          });
        });
      done();
    },
    choseWorkServiceItem() {
      console.log(this.serviceCategory.id);
      findItemsByCategory(this.serviceCategory.id).then(res => {
        let data = JSON.parse(res.data);
        this.joinsWorkServiceItems = data;
        console.log(res);
        console.log(data);
      });
      this.serviceItem = "";
    },
    choseServiceItem(data) {
      console.log(data);
      this.serviceItemId = data;
      console.log(this.serviceItemId);
    },
    userPass(row) {
      console.log(row);
      let obj = {};
      obj.id = row.id;
      userPass(obj).then(res => {
        this.handleList();
      });
    },
    userRefused(row) {
      this.$prompt("请输入拒绝理由", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^.{1,255}$/,
        inputErrorMessage: "请输入正确长度的备注信息1-255"
      }).then(({ value }) => {
        let obj = {};
        obj.id = row.id;
        obj.reason = value;
        userRefused(obj).then(res => {
          this.handleList();
        });
      });
    },
    immediatePayment(row) {
      this.config.value = "";
      let obj = {};
      obj.id = row.id;
      console.log(row);
      console.log(this);
      immediatePay(obj).then(response => {
        this.tableLoading = false;
        if (response.code == "200") {
          let data = response.data;
          wxNativePayQuery(data.outTradeNo).then(res => {
            console.log(res);
            if (res.code == "200") {
              if (res.data == "SUCCESS") {
                let _this = this;
                setTimeout(() => {
                  _this.QRCodeDialog = false;
                  _this.dialogBalancePay = false;
                  _this.$message({
                    showClose: true,
                    message: "支付成功",
                    type: "success"
                  });
                  _this.handleList();
                  this.handleList();
                }, 2000);
              } else {
                this.QRCodeDialog = false;
                this.dialogBalancePay = false;

                this.$message({
                  showClose: true,
                  message: "支付超时",
                  type: "error"
                });
              }
              this.handleList();
            } else {
              this.QRCodeDialog = false;
              this.dialogBalancePay = false;
              this.$message({
                showClose: true,
                message: "支付超时",
                type: "error"
              });
              this.handleList();
            }
          });

          let start = new Date().getTime();
          while (true) if (new Date().getTime() - start > 1) break;

          this.config.value = "";
          this.config.value = data.codeUrl;
          console.log("集合：" + this.config.value);
          this.QRCodeDialog = true;
        } else {
          this.$message({
            showClose: true,
            message: response.message,
            type: "error"
          });
          // this.$refs.crud.rowAdd();
          return;
        }
        // let data = JSON.parse(res.data);
      });
    },
    showEvaluate(row) {
      this.evaluateObj.workOrderId = row.id;
      this.evaluateDialog = true;
    },
    rateChange() {
      //alert(this.evaluateObj.score);
    },
    evaluate() {
      // this.evaluateObj.workOrderId=row.id;
      console.log("集合：" + JSON.stringify(this.evaluateObj));
      // evaluation(this.serviceCategory.id).then((res) => {
      //     let data = JSON.parse(res.data)
      //     this.joinsWorkServiceItems = data
      // })

      evaluation(this.evaluateObj)
        .then(response => {
          if (response.code == "200") {
            this.$message({
              showClose: true,
              message: "评价成功",
              type: "success"
            });
            this.handleList();
            this.evaluateDialog = false;
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error"
            });
          }
        })
        .catch(error => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: error,
            type: "error"
          });
        });
    },
    serviceListing(row) {
      console.log(row);
      this.dataDialog = true;
      serviceListing(row.id).then(res => {
        this.workOrderData = [];
        this.serviceFee = [];
        this.propertiesViceList = [];
        let data = JSON.parse(res.data);
        this.workOrderData = data;
        this.propertiesViceList = data.propertiesViceList;
        let obj = { key: "收费标准", value: data.serviceFee.servicePrice };
        let obj1 = {
          key: "其他费用",
          value: data.serviceFee.otherExpensesAmount
        };
        let obj2 = {
          key: "其他费用备注",
          value: data.serviceFee.otherChargesDesc
        };
        let obj3 = { key: "总费用", value: data.serviceFee.servicePriceTotal };
        this.serviceFee.push(obj);
        this.serviceFee.push(obj1);
        this.serviceFee.push(obj2);
        this.serviceFee.push(obj3);
        console.log("工单详情:" + JSON.stringify(this.propertiesViceList));
        console.log("serviceFee:" + JSON.stringify(this.serviceFee));
      });
    },
    formmaterImage(row) {
      let str = new Array();
      console.log("row：" + JSON.stringify(row));
      if (row != null) {
        let picArray = row.split(",");
        for (let i = 0; i < picArray.length; i++) {
          // console.log("url："+ row[i].url)
          str.push(picArray[i]);
        }
      }
      return str;
    },
    cancelWorkOrder(id) {
      this.$confirm(`是否确认取消?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          cancelWorkOrder(id)
            .then(response => {
              if (response.code == "200") {
                this.$message({
                  showClose: true,
                  message: "取消成功",
                  type: "success"
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "error"
                });
              }
            })
            .catch(error => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: error,
                type: "error"
              });
            });
        })
        .catch(() => {});
    },
    downloadExcelWorkOrder() {
      // this.downloadData.userType = "JOINS_AGENT";
      // findUserInfo().then(res => {
      //   let data = JSON.parse(res.data);
      //   this.downloadData.userId = data.id;
      //   downloadExcelWorkOrder(this.downloadData);
      // });
      // downloadExcelWorkOrder(this.downloadData);
      let params = this.downloadData;
      delete params.page;
      params.size = this.page.total;
      findWorkOrderList(params).then(res => {
        let data = JSON.parse(res.data);
        const list = data.rows;
        for (let i of list) {
          console.log(i);
          i.purchaseStatus = parseStatus(
            DIC.STOCK_REMOVAL_STATUS,
            i.purchaseStatus
          );
          i.status = parseStatus(DIC.WORK_ORDER_STATUS, i.status);
          if (i.payTime) {
            i.payTime = formatterDateToUTC(i.payTime * 1);
          } else {
            i.payTime = i.payTime == null ? "" : i.payTime;
          }
          i.workUserId = i.workUserId == null ? "" : i.workUserId;
          i.realName = i.realName == null ? "" : i.realName;
          // i.payTime = formatterDateToUTC(i.payTime * 1);
          // i.totalMoney = i.totalMoney == null ? 0 : i.totalMoney;
          // i.returnReason = i.returnReason == null ? "" : i.returnReason;
        }
        const header = [];
        for (let i of this.tableOption.column) {
          const obj = {};
          if (
            i.prop == "province" ||
            i.prop == "city" ||
            i.prop == "area" ||
            i.prop == "provinces" ||
            i.prop == "reservationTime" ||
            i.prop == "workUserName" ||
            i.prop == "remarks" ||
            i.prop == "startDate_endDate" ||
            i.prop == "payTimeInterval"
          ) {
            ("");
          } else if (i.prop == "workUserId") {
            obj.k = "realName";
            obj.v = "工程师";
            header.push(obj);
          } else if (i.prop == "serviceCategory") {
            obj.k = "serviceCategoryName";
            obj.v = "服务类目";
            header.push(obj);
          } else if (i.prop == "serviceItems") {
            obj.k = "serviceItemName";
            obj.v = "服务项目";
            header.push(obj);
          } else {
            obj.k = i.prop;
            obj.v = i.label;
            header.push(obj);
          }
        }
        const fileName = "预约单管理.xlsx";
        exportExcel(header, list, fileName);
      });
    },
    async fnUploadremittanceImgs(option) {
      this.tableLoading = true;
      getAliyunPublicToken().then(res => {
        let data = JSON.parse(res.data);
        let client = new oss({
          region: data.point,
          endPoint: data.point,
          accessKeyId: data.accessKeyId,
          accessKeySecret: data.accessKeySecret,
          Expiration: data.expiration,
          bucket: data.bucketName,
          stsToken: data.securityToken
        });
        const storeAs = md5(option.file.name) + new Date().getTime();
        client
          .multipartUpload(storeAs, option.file, {})
          .then(results => {
            let res = results.res.requestUrls;
            let files = new Array();
            for (let url in res) {
              let file = new Object();
              file.label = storeAs;
              file.value = url;
              files.push(file);
            }
            this.fileList1 = files;
            let array = results.res.requestUrls[0].split("?");
            this.remittanceImgs.push(array[0]);
            this.tableLoading = false;
          })
          .catch(err => {
            console.log(err);
          });
      });
    }
  }
};
</script>

<style lang="scss">
.remittanceButton {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
}
.remittance {
  .recharge {
    margin-top: 10px;
  }
}
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
